<template>
  <div class="dropdown-search p-lg">
    <div>
      <div class="filter-title m-b-sm">
        Operación
      </div>
      <b-field>
        <b-radio-button
          v-for="(adTypeOption, index) in adTypeOptions"
          v-model="selectedAdTypes"
          :key="`ad-type-${index}`"
          :native-value="adTypeOption"
        >
          <span>{{ propertyAdType.get[adTypeOption] }}</span>
        </b-radio-button>
      </b-field>
    </div>
    <div class="m-t-md">
      <div class="filter-title m-b-sm">
        Inmueble
      </div>
      <b-button
        v-for="propertyType in propertyTypeOptions"
        :key="`property-type-${propertyType.id}`"
        class="m-r-sm m-b-sm"
        :class="{
          selected: selectedPropertyTypes.find(el => el.id === propertyType.id)
        }"
        @click="selectPropertyType(propertyType)"
      >
        {{ propertyType.name }}
      </b-button>
    </div>
    <div class="m-t-md">
      <b-button
        class="has-text-weight-semibold"
        type="is-primary"
        @click="handleSearch"
      >
        Buscar
      </b-button>
    </div>
  </div>
</template>

<script>
import PropertyAdType from "@/constants/properties/ad-type";

export default {
  name: "DropdownSearch",

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      adTypeOptions: [PropertyAdType.NUM_RENT, PropertyAdType.NUM_SALE],
      selectedAdTypes: null,
      propertyAdType: PropertyAdType,
      // selectedAdTypes: [],
      selectedPropertyTypes: []
    };
  },

  watch: {
    filter: {
      deep: true,
      handler(newVal, oldVal) {
        this.selectedAdTypes = newVal.adType;
        this.selectedPropertyTypes = [...newVal.propertyTypes];
      }
    }
  },

  computed: {
    filter() {
      return this.$store.getters["filter/filter"];
    },
    propertyTypeOptions() {
      return this.$store.state.search.propertyTypes;
    }
  },

  beforeMount() {
    this.$store.dispatch("search/getSearchFilterOptions");
  },

  methods: {
    selectPropertyType(propertyType) {
      const propertyTypeIndex = this.selectedPropertyTypes.findIndex(
        el => el.id === propertyType.id
      );
      if (propertyTypeIndex === -1) {
        this.selectedPropertyTypes.push(propertyType);
      } else {
        this.selectedPropertyTypes.splice(propertyTypeIndex, 1);
      }
    },

    handleSearch() {
      this.$store.commit("filter/update_adtype", this.selectedAdTypes);
      this.$store.commit("filter/update_adtypes", []);
      this.$store.commit("filter/reset_propertytypes");
      this.selectedPropertyTypes.map(obj =>
        this.$store.commit("filter/update_propertytypes", obj)
      );

      this.$emit("search");
      this.$emit("hide", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown-search {
  width: 450px;
  border-radius: 0 0 $radius $radius;
  background-color: #ffffff;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.25);
}

.filter-title {
  font-size: 0.8em;
  font-weight: $weight-semibold;
}

.selected {
  box-sizing: border-box;
  border: 1px solid $primary;
  border-radius: 4px;
  background-color: rgba(40, 110, 200, 0.1);
  color: $primary;
}
</style>
